"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPageContainer = exports.Headline = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.Headline = styled_components_1.default.div `
	text-align: left;
	flex: 0 0 auto;
	& > * {
		color: ${({ theme }) => theme.color.brand1};
	}
	h1 {
		font-size: 2.4em;
		font-weight: bold;
		margin-bottom: 0.5em;
	}
`;
const Container = styled_components_1.default.div `
	padding: 2em 1em 0;
`;
const Header = styled_components_1.default.div `
	margin-bottom: 2rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 1rem;
	flex-wrap: wrap;
`;
const Actions = styled_components_1.default.div `
	align-items: flex-start;
	display: flex;
	flex-wrap: wrap;
	flex: 0 0 auto;
	justify-content: flex-end;
`;
const Description = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.black};
	font-size: 1rem;
	margin-bottom: 2rem;
`;
const AdminPageContainer = ({ title, description, actions, children }) => {
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)(Header, { children: [(0, jsx_runtime_1.jsx)(exports.Headline, { children: (0, jsx_runtime_1.jsx)("h1", { children: title }) }), actions && (0, jsx_runtime_1.jsx)(Actions, { children: actions })] }), description && (0, jsx_runtime_1.jsx)(Description, { children: description }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children })] }));
};
exports.AdminPageContainer = AdminPageContainer;
